var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstituentFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42857 9.92308V19.6154H20.5714V9.92308H3.42857ZM2.71429 8.53846H21.2857C21.4752 8.53846 21.6568 8.6114 21.7908 8.74123C21.9247 8.87107 22 9.04716 22 9.23077V20.3077C22 20.4913 21.9247 20.6674 21.7908 20.7972C21.6568 20.9271 21.4752 21 21.2857 21H2.71429C2.52485 21 2.34316 20.9271 2.20921 20.7972C2.07525 20.6674 2 20.4913 2 20.3077V9.23077C2 9.04716 2.07525 8.87107 2.20921 8.74123C2.34316 8.6114 2.52485 8.53846 2.71429 8.53846ZM4.14286 5.76923H19.8571V7.15385H4.14286V5.76923ZM6.28571 3H17.7143V4.38462H6.28571V3Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstituentFiles);
export default __webpack_public_path__ + "static/media/Constituent Files.678ba6336eee85d882cc21b76cfabcb3.svg";
export { ForwardRef as ReactComponent };